import React from "react";

const LanguageSelector = ({ language, onChange, disabled = false }) => {
  return (
    <select
      value={language}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      className={`
        px-2
        py-1
        text-sm
        font-medium
        rounded
        border
        bg-white
        text-gray-900
        dark:bg-gray-800
        dark:text-gray-100
        focus:outline-none
        focus:ring-2
        transition
        duration-150
        ease-in-out
        ${
          disabled
            ? "border-gray-300 dark:border-gray-600 bg-gray-100 dark:bg-gray-700 cursor-not-allowed opacity-60"
            : "border-gray-300 dark:border-gray-600 focus:ring-[#A66FFF] focus:border-[#4B1498]"
        }
      `}
      title={disabled ? "Language is locked to the selected language" : "Select programming language"}
    >
      <option value="c">C</option>
      <option value="cpp">C++</option>
      <option value="java">Java</option>
      <option value="python">Python</option>
      <option value="javascript">JavaScript</option>
      <option value="react">React</option>
      <option value="angular">Angular</option>
      <option value="perl">Perl</option>
      <option value="go">Go</option>
      <option value="sql">SQL</option>
    </select>
  );
};

export default LanguageSelector;
